import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import SignIn from './components/Auth/SignIn';
import SignUp from './components/Auth/SignUp';
import Layout from './components/Layout';
import SurveyContainer from './components/Survey/SurveyContainer';
import MasterClass from './components/Survey/Masterclass/MasterClass'; // Import MasterClass
import UserProfile from './components/UserProfile/UserProfile'; // Adjust the path as needed
import { auth, db } from './utils/firebase-config';
import { doc, getDoc } from "firebase/firestore";
import { LoadingProvider } from './context/LoadingContext';


const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUserId(user.uid);
        setIsSignedIn(true);
        setIsLoading(false);
      } else {
        setIsSignedIn(false);
        setIsLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <LoadingProvider>
    <Router>
      <Layout>
        <Routes>
          <Route path="/signin" element={isSignedIn ? <Navigate to="/survey" replace /> : <SignIn />} />
          <Route path="/signup" element={isSignedIn ? <Navigate to="/survey" replace /> : <SignUp />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/survey/0/:subStepId" element={isSignedIn ? <MasterClass /> : <Navigate to="/signin" replace />} />
          <Route path="/survey/:stepId" element={isSignedIn ? <SurveyContainer userId={userId} /> : <Navigate to="/signin" replace />} />
          <Route path="/survey" element={isSignedIn ? <SurveyContainer userId={userId} /> : <Navigate to="/signin" replace />} />
          <Route path="/" element={<Navigate to={isSignedIn ? "/survey" : "/signup"} replace />} />
        </Routes>
      </Layout>
    </Router>
    </LoadingProvider>

  );
};

export default App;
